import script from "./mobie-preview.vue?vue&type=script&setup=true&lang=ts"
export * from "./mobie-preview.vue?vue&type=script&setup=true&lang=ts"

import "./mobie-preview.vue?vue&type=style&index=0&id=7a1b0f10&scoped=true&lang=css"

import exportComponent from "E:\\vs2019\\face-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a1b0f10"]])

export default __exports__